import {
  BaseFormComponent,
  BaseFormHeaderInfo
} from '../../tasks/baseFormComponent/baseForm.component';
import { Component, OnInit, Optional, ElementRef, Input, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { tap, finalize, switchMap, catchError } from 'rxjs/operators';
import { ContractModificationDTO, ProjectEntityDTO, ResultTypeDTO, ObjectContextDTO, ContractDTO, CompanyDocDTO } from '../../api/plyca-dtos-v2';
import { Observable, of, forkJoin } from 'rxjs';
import { Configuration } from '../../conf/app.constants';
import { FormConfig } from '../../components/forms/form.objects';
import { MasterDataDTO, WorkContractMoficationDTO, getSimpleIdentifierFromString } from '../../api/plyca-dtos';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { AYMADContractModificationValidations } from './AYMADContractModification.validation';
import * as lodash from 'lodash';
import { UnitPricesListComponent } from '../../dossiers/unitPrices/UnitPricesList.component';
import { DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { AntecedentAYMADComponent } from '../antecedent/antecedentAYMAD.component';



@Component({
  selector: 'contractModification-form',
  templateUrl: './aymadContractModifications.template.html',
  providers: [AYMADContractModificationValidations]
})

export class AYMADContractModificationComponent
  extends BaseFormComponent<ContractModificationDTO, ContractModificationDTO>
  implements OnInit, OnDestroy {
  private identifier: string;
  // private formService: FormService;

  // Identificador de incidencia
  private type: string; // Tipo de la incidencia
  private projectIdentifier: string; // Identiificador del expediente
  private contractDivision: string; // Division padre de la incidencia
  private contract: ContractDTO; // Contrato padre de la incidencia
  private actualCompanyDoc: CompanyDocDTO; //
  private workContractModification: WorkContractMoficationDTO; // Tarea de la incidencia
  private contexWork: ObjectContextDTO; // Contexto de la tarea de la incidencia
  // private contexWork: ObjectContextDTO; // Contexto de la tarea de la incidencia
  // Si viene desde una tarea pasa del readOnly siempre es false
  private readonly = false;
  private attrCAUSAS_RSC_GEN_ESP: string;
  private attrCAUSAS_RSC_GEN_OTR: string;
  private specificCauseRSCVisible: boolean;
  private otherCauseRSCVisible: boolean;

  @Input()
  project: ProjectEntityDTO;


  constructor(
    public configuration: Configuration,
    private contractModificationValidations: AYMADContractModificationValidations,
    elem: ElementRef,
    public router: Router,
    @Optional() protected activatedRoute: ActivatedRoute,
    public helpService: HelpService,
    private plycaErrorHandler: PlycaErrorHandler
  ) {
    super(elem);
  }

  ngOnDestroy() {
    this.headerActionsService.clearWindowActions(this.windowHash);
    super.ngOnDestroy();
  }

  ngOnInit(): void {
    let helpTags = [];
    if (this.task) {
      helpTags = helpTags.concat([HelpType.NEW_CONTRACTMODIFICATION, 'INCIDENCIA_' + this.task.work.contractModification.alias]);
      console.log('INVOCACION DE CONTRACTMODIFICATION DESDE TAREA', this.task);
      // ayuda con tarea
      this.subscribe(this.helpService.getStoreTagsObservable().pipe(
        switchMap((taskHelpTags) => {
          helpTags = taskHelpTags.concat(helpTags);
          return this.helpService.showContextHelpObservable(helpTags)
        })));

      this.workContractModification = this.task.work;
      this.identifier = this.task.work.contractModification.identifier;
      this.projectIdentifier = this.task.work.contractModification.division.parent.project.identifier;
      let contractDiv = this.task.work.contractModification.division.parent.identifier;
      this.contract = this.task.work.contractModification.contract;
      this.contractDivision = contractDiv.toString().substring(0, contractDiv.indexOf('<>'));
      super.ngOnInit();
    } else {
      this.subscribe(this.activatedRoute.params
        .pipe(tap(params => (this.identifier = params['id']))));
      this.activatedRoute.queryParams.subscribe(params => {
        if (params['readOnly']) {
          this.readonly = params['readOnly'];
        }
        this.projectIdentifier = params['projectIdentifier'];
        this.contractDivision = params['contractDivision'];
        this.type = params['type'];
        this.subscribe(this.helpService.showContextHelpObservable([HelpType.NEW_CONTRACTMODIFICATION, 'INCIDENCIA_' + this.type]));
      });
      super.ngOnInit();
    }
  }

  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    this.loadFunctions(formConfig);
    formConfig.readonly = this.readonly;
    return super.configureFormConfig(formConfig);
  }


  getFormSettingURL(): string {
    return 'contractModifications/contractModificationInterfaceSettings_' + this.type + '.json';
  }

  getServiceURL(): string {
    return this.configuration.CONTRACT_MODIFICATIONS_SERVICE_URL;
  }


  /*private ignoreError(e: any, channeFormURL: string): ObservableInput<InterfaceSettings> {
    console.error('Error al obtener definicion del formulario ' + channeFormURL);
    return of(undefined);
  }*/

  /*private newFormConfig(): FormConfig {
    let formConfig: FormConfig;
    formConfig = new FormConfig('contractModifications/contractModificationInterfaceSettings_.json', undefined, this.model);
    return formConfig;
  }*/

  getObjectIdentifier(): string {
    if (this.task) {
      return undefined;
    } else if (this.identifier === 'new') {
      return this.identifier + '?projectIdentifier=' + this.projectIdentifier + '&contractDivision='
        + this.contractDivision + '&type=' + this.type;
    } else {
      return this.identifier;
    }
  }

  dtoToModel(dto: ContractModificationDTO): Observable<ContractModificationDTO> {
    // SERVIDOR A CLIENTE
    this.specificCauseRSCVisible = false;
    this.otherCauseRSCVisible = false;
    if (dto.alias) {
      this.type = dto.alias;
    }

    if ('MDC' === this.type) {
      // this.initBudgetAccountLines = dto.budget.budgetAccountLines;
      AYMADContractModificationValidations.initCumulativePriceVariation(dto);
    }

    if ('PRC' === this.type) {
      let isFrameworkAgremeent = AYMADContractModificationValidations.isFrameworkAgremeent(dto);
      let contractExtensionType0 = new MasterDataDTO('0', 'TIPO_PRORROGA');
      let contractExtensionType1 = new MasterDataDTO('1', 'TIPO_PRORROGA');
      dto.contractExtensionTypesPRC = [];
      if (isFrameworkAgremeent) {
        contractExtensionType0.description = 'Prevista en el pliego que rige el acuerdo marco';
        contractExtensionType1.description = 'Por no haberse formalizado el acuerdo marco';
      } else {
        contractExtensionType0.description = 'Prevista en el pliego que rige el contrato';
        contractExtensionType1.description = 'Por no haberse formalizado el nuevo contrato';
      }
      dto.contractExtensionTypesPRC.push(contractExtensionType0);
      dto.contractExtensionTypesPRC.push(contractExtensionType1);
    }

    if ('SBC' === this.type) {
      if (dto?.contract?.company?.temporaryConsortium != null) {
        if (dto.temporaryConsortium === undefined || dto.temporaryConsortium === null){
          dto.temporaryConsortium = new MasterDataDTO('', '');
        }

        if (!dto.contract.company.temporaryConsortium) {
          dto.temporaryConsortium.identifier = '0<>TIPO_CONTRATISTA_SUCESION';
          dto.temporaryConsortium.description = 'Contratista no es UTE';
        } else {
          dto.temporaryConsortium.identifier = '1<>TIPO_CONTRATISTA_SUCESION';
          dto.temporaryConsortium.description = 'Contratista es UTE';
        }
          dto.temporaryConsortiumText = dto.temporaryConsortium?.description !== undefined ?
            dto.temporaryConsortium.description :
            '';
      }
    }

    this.contract = dto.contract;
    if (this.contract && this.contract.companyDoc) {
      this.contract.companyDoc.forEach(companyDoc => {
        if (companyDoc.type === 'A') {
          this.actualCompanyDoc = companyDoc;
        }
      });
    }

    if ('RSC' === this.type) {
      this.loadDataRSC();
    }

    this.contract = dto.contract;
    if (this.contract && this.contract.companyDoc) {
      this.contract.companyDoc.forEach(companyDoc => {
        if (companyDoc.type === 'A') {
          this.actualCompanyDoc = companyDoc;
        }
      });
    }


    // Se establecen las configueraciones del conteexto de tarea
    this.setUIConfigurations(dto);
    return of(dto);
  }

  normalizaDossierId(dossierId: string): string {
    return dossierId.substring(0, 4) + '/' + dossierId.substring(4);
  }

  setUIConfigurations(dto: ContractModificationDTO) {
    // Se inicializa el UI
    dto['ui'] = {};

    // Se inicializan los valores por defecto en el caso de que no vengan de tarea
    dto['ui'].visibleAgreementDate = false;
    dto['ui'].visibleStartDate = false;
    dto['ui'].visibleEndDate = false;
    dto['ui'].disabledAllSSC = false;
    dto['ui'].enabledBudgetAccountLine = true;
    dto['ui'].enabledReason = true;
    dto['ui'].enabledNote = true;
    dto['ui'].newProjectId = this.normalizaDossierId(dto.division.parent.project.identifier);
    if (dto.context.configurations['enabledLots']) {
      dto['ui'].enabledLot = dto.context.configurations['enabledLots'].value;
    }

    dto['ui'].projectIdentifier = '';
    dto['ui'].contractDivision = '';

    if (this.projectIdentifier) {
      dto['ui'].projectIdentifier = this.projectIdentifier;
    }
    if (this.contractDivision) {
      dto['ui'].contractDivision = this.contractDivision;
    }


    // Se inicializan las configuraciones de tarea
    if (this.workContractModification && this.workContractModification.context
      && this.workContractModification.context.configurations !== undefined) {
      this.contexWork = this.workContractModification.context;

      if (this.type === 'SSC') {
        // Fecha de Inicio
        if (this.contexWork.configurations['visibleStartDate']) {
          let visibleStartDate = this.contexWork.configurations['visibleStartDate'];
          if (visibleStartDate !== undefined && visibleStartDate !== '' && visibleStartDate !== null) {
            dto['ui'].visibleStartDate = visibleStartDate.value;
          }
        }
        // Fecha de Fin
        if (this.contexWork.configurations['visibleEndDate']) {
          let visibleEndDate = this.contexWork.configurations['visibleEndDate'];
          if (visibleEndDate !== undefined && visibleEndDate !== '' && visibleEndDate !== null) {
            dto['ui'].visibleEndDate = visibleEndDate.value;
          }
        }
        // Habilitar toda la incidencia
        if (this.contexWork.configurations['disabledAllSSC']) {
          let disabledAllSSC = this.contexWork.configurations['disabledAllSSC'];
          if (disabledAllSSC !== undefined && disabledAllSSC !== '' && disabledAllSSC !== null) {
            dto['ui'].disabledAllSSC = disabledAllSSC.value;
            if (disabledAllSSC.value) {
              dto['ui'].visibleEndDate = true;
              dto['ui'].visibleStartDate = true;
            }
          } else {
            dto['ui'].disabledAllSSC = false;
          }
        }


        /*if (this.contexWork.configurations['enabledBudgetAccountLine']) {
          // Anualidades
          dto['ui'].enabledBudgetAccountLine = this.contexWork.configurations['enabledBudgetAccountLine'].value;
        }

        // Objeto de la incidencia
        if (this.contexWork.configurations['enabledReason']) {
          dto['ui'].enabledReason = this.contexWork.configurations['enabledReason'].value;
        }
        // Observaciones de la incidencia
        if (this.contexWork.configurations['enabledReason']) {
          dto['ui'].enabledNote = this.contexWork.configurations['enabledNote'].value;
        }*/

      }
    }
  }
  getDataObservable(): ContractModificationDTO {
    if (this.workContractModification
      && this.workContractModification.contractModification) {
      return this.workContractModification.contractModification;
    }
    return undefined;
  }

  modelToDTO(model: ContractModificationDTO): ContractModificationDTO {
    // CLIENTE A SERVIDOR
    let dtoToSend: ContractModificationDTO;
    dtoToSend = lodash.cloneDeep(model);

    if (this.task !== undefined) {
      this.task.work.contractModification = model;
    }

    if (AYMADContractModificationValidations.isFrameworkAgremeent(this.model)) {
      if (this.model?.budget?.budgetAccountLines !== undefined && this.model.budget.budgetAccountLines.length > 0) {
        this.model.budget.budgetAccountLines.forEach(line => {
          line.year = 0;
        });
      }
    }
    if ('SCN' === this.type) {
      if (model.subcontratedCompany !== undefined && model.subcontratedCompany.length > 0) {
        let order = 1;
        model.subcontratedCompany.forEach(subcontractedCompany => {
          subcontractedCompany.order = order++;
        });
      }
    }

    dtoToSend = JSON.parse(
      JSON.stringify(model, (k, v) => (k === '_parent' ? undefined : v))
    );
    model.origin = 'FI';
    return dtoToSend;
  }

  /*getTitle(model: ContractModificationDTO): string {
    if (model) {
      return model.identifier + ' - ';
    } else {
      return 'Nuevo grupo';
    }
  }*/

  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    headerInfo.titleKey = 'Ficha de Incidencia';
    headerInfo.titleIcon = 'fas fa-file-invoice';

    if (this.model && this.model.division && this.model.division.parent && this.model.division.parent.project) {
      headerInfo.project = this.model.division.parent.project;
    }
    return headerInfo;
  }


  initHeaderActions() {
    if (this.model.procurementProjectInfo?.complementarySystem !== undefined &&
      this.model.procurementProjectInfo?.complementarySystem?.identifier === 'AM<>SISTCOMPLEMENTARIO') {
          if (this.model.alias === 'PRC') {
            let projectWithoutUnitPrices = this.model.procurementProjectInfo.withoutUnitPrice;
            let visibleUnitPrices = false;
              if (!projectWithoutUnitPrices) {
              let atribParams = 'APLICACION=' + this.model.division.parent.project.identifier + '_';
              if (this.model.division?.identifier !== undefined) {
                let contractModificationDivision = getSimpleIdentifierFromString(this.model.division.identifier);
                atribParams = atribParams + contractModificationDivision;
                this.subscribe(this.plycaService
                .getAttributeValue('MODIFICAR_PRECUNITARIOS_FI', atribParams)
                .pipe(
                  finalize(() => {
                    this.configureButtons(visibleUnitPrices);
                  })),
                (result: any) => {
                  if (result && result.values && result.values.length > 0) {
                    visibleUnitPrices = true;
                  }
                });
              } else {
                this.configureButtons(false);
              }
            }
          } else {
            let showUnitPrices = (this.model.alias === 'MDC' || this.model.alias === 'RVP');
            this.configureButtons(showUnitPrices);
          }
      } else {
        this.configureButtons(false);
      }

  }

  configureButtons(showUnitPrices: boolean) {
    this.subscribe(
      this.headerActionsService.addAction('Antecedentes', 'fas fa-history', 'btn-primary', true),
      () => {
        this.openAntecedent();
      }
    );
    this.subscribe(
      this.headerActionsService.addAction('Verificar', 'fas fa-check', 'btn-primary', !this.readonly),
      () => {
        this.validateContractModification();
      }
    );
    showUnitPrices = showUnitPrices;
    if (showUnitPrices) {
      this.subscribe(this.headerActionsService
        .addAction('Precios Unitarios', 'fas fa-check', 'btn-primary', true)
        , (() => {
          this.openUnitPricesEditor();
        }));
    }
    //if (this.task || this.isContractModificationEditable()) {
    if (true) {
      this.subscribe(this.headerActionsService.addAction('General.save', 'fas fa-save', 'btn-primary', true),
        () => {
          let dto = this.modelToDTO(this.model);
          if (this.task !== undefined) {
            this.saveIfValidContext(true, dto, this.getValidationContext())
            .subscribe(
                (response) => {
                    this.setUIConfigurations(this.model);
                },
                (error) => {
                    console.error('Error:', error);
                }
            );

            /*this.subscribe(this.saveIfValidContext(true, dto, this.getValidationContext()));
            this.setUIConfigurations(this.model);*/

          } else {
            this.waitService.startWaiting();
            this.subscribe(this.validateContext(false, dto, this.getValidationContext())
              , result => {
                if (result.result === ResultTypeDTO.ERROR) {
                  this.waitService.cancelWaiting();
                  this.uiService.showConfirmMessage({
                    message: 'Se han detectado errores que impiden la tramitación. ¿Desea guardar la incidencia?',
                    header: 'Confirmacion',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                      console.log('Grabando incidencia...');
                      this.waitService.startWaiting();
                      this.subscribe(this.saveContext(false, dto, this.getValidationContext()),
                        _model => {
                          if (_model) {
                            this.goToDossierInfo(_model);
                          } else {
                            this.goToDossierInfo(dto);
                          }
                        });

                    },
                    reject: () => {
                      console.log('No hace nada...');
                    }

                  });
                } else if (result.result === ResultTypeDTO.OK) {
                  this.subscribe(this.saveContext(false, dto, this.getValidationContext()), _model => {
                    this.waitService.startWaiting();
                    if (_model) {
                      this.goToDossierInfo(_model);
                    } else {
                      this.goToDossierInfo(dto);
                    }
                  });
                } else {
                  // Error de validación FATAL
                  this.waitService.cancelWaiting();
                }
              }
            )
          }
          /*if (this.task) {
            this.subscribe(this.saveIfValidContext(true, dto, this.getValidationContext()));
          } else {
            this.waitService.startWaiting();
            this.subscribe(super.saveIfValidContext(false, dto, this.getValidationContext()),
              (result: any) => {
                if (!result || !this.formService.isValidationResponse(result)) {
                  // Si todo ok se consulta si hay que tramitar
                  let identifier = this.model.identifier ? this.model.identifier : result.identifier;
                  this.subscribe(
                    this.plycaService.get<ContractModificationDTO>(
                      this.configuration.CONTRACT_MODIFICATIONS_SERVICE_URL,
                      identifier),
                    (_contractModification: ContractModificationDTO) => {
                      this.waitService.cancelWaiting();
                      this.showConfirmMessage(_contractModification);
                    },
                    (error) => {
                      this.waitService.cancelWaiting();
                      this.plycaErrorHandler.showServerError(error);
                    });
                } else {
                  this.waitService.cancelWaiting();
                }
              },
              (error) => {
                this.waitService.cancelWaiting();
                this.plycaErrorHandler.showServerError(error);
              }
            );
          }*/
        }
      );
      this.headerActionsService.addDivider();
    }
    this.addBackAction();

  }

  getValidationContext() {
    let nameValidation = '';
    if (this.model && this.model.context && this.model.context.configurations &&
      this.model.context.configurations.validateReplyca) {
      nameValidation = this.model.context.configurations.validateReplyca.value;
    }
    let validationCtx = this.model.identifier ? (nameValidation + 'Update') : (nameValidation + 'Insert');
    return validationCtx;
  }


  goToDossierInfo(_contractModification: ContractModificationDTO) {
    this.router.navigate(['dossierInfo/' + _contractModification.division.project.identifier], {
      queryParams: { component: 'CONTRACTSAYMAD' }
    });
  }

  isContractModificationEditable() {
    let _contactModification = this.model;
    if (_contactModification && _contactModification.document) {
      return _contactModification.document.currentState.identifier === '17';
    } else {
      return true;
    }
  }

  loadFunctions(_formConfig: FormConfig) {
    console.log('loadFunctions');
    _formConfig.functions.push({
      identifier: 'isBasedContract',
      fn: this.contractModificationValidations.isBasedContract.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'isFrameworkAgremeent',
      fn: this.contractModificationValidations.isFrameworkAgremeent.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'isFrameworkAgremeentTable',
      fn: this.contractModificationValidations.isFrameworkAgremeentTable.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'isFrameworkAgremeentEditor',
      fn: this.contractModificationValidations.isFrameworkAgremeentEditor.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'visibleDataContractExtensionType0',
      fn: this.contractModificationValidations.visibleDataContractExtensionType0.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'visibleDataContractExtensionType1',
      fn: this.contractModificationValidations.visibleDataContractExtensionType1.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'setTextDurationDesc',
      fn: this.contractModificationValidations.setTextDurationDesc.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'isApportioned',
      fn: this.contractModificationValidations.isApportioned.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'setTotalAmount',
      fn: this.contractModificationValidations.setTotalAmount.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'visibleTaxRate',
      fn: this.contractModificationValidations.visibleTaxRate.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'editableTaxRate',
      fn: this.contractModificationValidations.editableTaxRate.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'isPNCType0',
      fn: this.contractModificationValidations.isPNCType0.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'isPNCType1',
      fn: this.contractModificationValidations.isPNCType1.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'visiblePNCType0',
      fn: this.contractModificationValidations.visibleAMPType0.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'visibleAMPType0',
      fn: this.contractModificationValidations.visibleAMPType0.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'specificCauseVisible',
      fn: this.contractModificationValidations.specificCauseVisible.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'isEconomicMDC',
      fn: this.contractModificationValidations.isEconomicMDC.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'isDurationMDC',
      fn: this.contractModificationValidations.isDurationMDC.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'clearEconomicDataMDC',
      fn: this.clearEconomicDataMDC.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'onChangeFunctionIncreaseDecreaseMDC',
      fn: this.onChangeFunctionIncreaseDecreaseMDC.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'clearDurationDataMDC',
      fn: this.contractModificationValidations.clearDurationDataMDC.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'calculateAmountsMDC',
      fn: this.contractModificationValidations.calculateAmountsMDC.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'onChangeTaxType',
      fn: this.contractModificationValidations.onChangeTaxType.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'getProjectIdentifier',
      fn: this.contractModificationValidations.getProjectIdentifier.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'getContractModificationDivision',
      fn: this.contractModificationValidations.getContractModificationDivision.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'isWorks',
      fn: this.contractModificationValidations.isWorks.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'getTextTableBudgetAccountLines',
      fn: this.contractModificationValidations.getTextTableBudgetAccountLines.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'isRJA',
      fn: this.contractModificationValidations.isRJA.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'visibilityTittleEconomicData',
      fn: this.contractModificationValidations.visibilityTittleEconomicData.bind(this)
    });


    _formConfig.functions.push({
      identifier: 'isVisibleColumnDateAntecedent',
      fn: this.contractModificationValidations.isVisibleColumnDateAntecedent.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'isACompensation',
      fn: this.contractModificationValidations.isACompensation
    });

    _formConfig.functions.push({
      identifier: 'clearForm',
      fn: this.contractModificationValidations.clearForm
    });

    _formConfig.functions.push({
      identifier: 'calculateTotalPNC',
      fn: this.contractModificationValidations.calculateTotalPNC
    });

    _formConfig.functions.push({
      identifier: 'visibleAdjustTenderSCN',
      fn: this.contractModificationValidations.visibleAdjustTenderSCN
    });

    _formConfig.functions.push({
      identifier: 'viewFormRevPrice',
      fn: this.contractModificationValidations.viewFormRevPrice.bind(this)
    });

    // SSC
    _formConfig.functions.push({
      identifier: 'editableRequestDateSSC',
      fn: this.contractModificationValidations.editableRequestDateSSC.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'clearRequestDateSSC',
      fn: this.contractModificationValidations.clearRequestDateSSC.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'editableTypeSSC',
      fn: this.contractModificationValidations.editableTypeSSC.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'clearTypeSSC',
      fn: this.contractModificationValidations.clearTypeSSC.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'getPriceRevisionFormulaDesc',
      fn: this.contractModificationValidations.getPriceRevisionFormulaDesc.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'isSundryTaxTypes',
      fn: this.contractModificationValidations.isSundryTaxTypes.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'isExemptTaxType',
      fn: this.contractModificationValidations.isExemptTaxType.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'getTextCompanySBC',
      fn: this.contractModificationValidations.getTextCompanySBC.bind(this)
    });
    _formConfig.functions.push({
      identifier: 'getIdentifierParentCauses',
      fn: this.contractModificationValidations.getIdentifierParentCauses.bind(this)
    });
    _formConfig.functions.push({
      identifier: 'visibleStartDateSSC',
      fn: this.contractModificationValidations.visibleStartDateSSC.bind(this)
    });
    _formConfig.functions.push({
      identifier: 'visibleEndDateSSC',
      fn: this.contractModificationValidations.visibleEndDateSSC.bind(this)
    });
    _formConfig.functions.push({
      identifier: 'filtraCausaPNC',
      fn: this.contractModificationValidations.filtraCausaPNC.bind(this)
    });











    _formConfig.functions.push({
      identifier: 'isSpecificAndOtherCausesVisibles',
      fn: this.isSpecificAndOtherCausesVisibles.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'isSpecificCauseRSCVisible',
      fn: this.isSpecificCauseRSCVisible.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'isOtherCauseRSCVisible',
      fn: this.isOtherCauseRSCVisible.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'plannedPeriodRequestDateEditability',
      fn: this.plannedPeriodRequestDateEditability.bind(this)
    });

    _formConfig.functions.push({
      identifier: 'isContractorResponability',
      fn: this.isContractorResponability.bind(this)
    });
  }

  validateContractModification() {
      let dto = this.modelToDTO(lodash.cloneDeep(this.model));

      this.subscribe(this.validateContext(true, dto, this.getValidationContext()),
        (result => {
          if (result.result === ResultTypeDTO.OK) {
            this.uiService.showMessage(
              'Se ha verificado correctamente.',
              'Información',
              'successStyle'
            );
          }
        }))
  }

  public onChangeFunctionIncreaseDecreaseMDC(model: any) {
    let isRJA = model.increaseDecrease_aymad !== undefined && model?.increaseDecrease_aymad.identifier === '2<>TIPO_MDC_ECONOMICA_AYMAD';
    if (isRJA) {
      this.clearEconomicDataMDC(model);
    }
  }

  // public clearEconomicDataMDC(model: any) {
  public clearEconomicDataMDC(model: any) {
    let isFrameworkAgremeent = AYMADContractModificationValidations.isFrameworkAgremeent(model);
    let isRJA = model.increaseDecrease_aymad !== undefined && model?.increaseDecrease_aymad.identifier === '2<>TIPO_MDC_ECONOMICA_AYMAD';
    let isEconomicMDC = model.isEconomicContractModification !== undefined && model.isEconomicContractModification;
    if (!isFrameworkAgremeent) {
      if (!isEconomicMDC || (isEconomicMDC && isRJA)) {
        if (!isEconomicMDC) {
          model.increaseDecrease_aymad = undefined;
          model.budget.budgetAccountLines = undefined;
        }
        if (model.budget !== undefined) {
          model.budget.amountExcludingTaxes = undefined;
          model.budget.totalTaxes = undefined;
          model.budget.totalAmount = undefined;
          model.budget.taxType = undefined;
          model.budget.priceVariation = undefined;
          model.budget.cumulativePriceVariation = undefined;
        }
      } else if (isEconomicMDC) {
        if (model.budget !== undefined) {
          model.budget.budgetAccountLines = [...model.budget.initBudgetAccountLines];
          model.budget.taxType = model.procurementProjectInfo.taxType;
          // model.budget.cumulativePriceVariation = this.initCumulativePriceVariation;
        }
        AYMADContractModificationValidations.initCumulativePriceVariation(model);
      }
    }
  }

  openUnitPricesEditor() {
    let existingContractModification = true;
    if (this.model.division !== undefined && this.model.division.identifier !== undefined) {
      let divisionIdentifier = getSimpleIdentifierFromString(this.model.division.identifier);
      if (divisionIdentifier === undefined || 'nulo' === divisionIdentifier) {
        existingContractModification = false;
      }
    } else {
      existingContractModification = false;
    }
    if ('MDC' === this.type && (this.model.hasUnitPrices === undefined
      || (this.model.hasUnitPrices !== undefined && !this.model.hasUnitPrices))) {
        this.uiService.showMessage('No pueden introducirse precios unitarios si no se ha marcado SI en el campo "Incidencia que afecta a los precios unitarios"',
          this.translate.instant('General.info'),
        'error');
    } else {
      if (!existingContractModification) {
        this.uiService.showConfirmMessage({
          message: 'Para gestionar precios unitarios, es necesario que la incidencia se grabe previamente. Pulse aceptar para grabar',
          header: 'Confirmacion',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            console.log('Grabando incidencia...');
            // GRABAMOS LA INCIDENCIA
            let dto = this.modelToDTO(this.model);
            this.waitService.startWaiting();
            this.subscribe(this.validateContext(false, dto, this.getValidationContext())
              , result => {
                if (result.result === ResultTypeDTO.FATAL) {
                  this.waitService.cancelWaiting();
                  this.uiService.showMessage('Solucione los errores antes de continuar.', 'Error', 'errorStyle');
                } else {
                  console.log('Grabando incidencia...');
                  this.waitService.startWaiting();
                  this.subscribe(this.saveContext(false, dto, this.getValidationContext()),
                    _model => {
                      this.model = _model;
                      console.log('Incidencia Grabada');
                      this.openUnitPrices();
                      this.waitService.cancelWaiting();
                    });
                }
              }
            )
          },
          reject: () => {
            console.log('No hace nada...');
          }
        });
      } else {
        this.openUnitPrices();
      }
    }
  }

  openUnitPrices() {
    let config: DynamicDialogConfig = {
      header: 'Edición de precios unitarios',
      width: '99%',
      style: { overflow: 'hidden', 'max-height': '100vh' },
      styleClass: 'formEdition'
    };
    let context = {};
    context['readonly'] = this.readonly;
    context['contractModification'] = this.model;
    config['context'] = context;
    config.data = {
      task: this.task
    };

    this.subscribe(this.dialogService.open(UnitPricesListComponent, config).onClose,
    (unitPrices: boolean) => {
    },
    (error: any) => {
      console.error(error);
    });
  }

  openAntecedent(contractModification?: ContractModificationDTO) {
    let config: DynamicDialogConfig = {
      header: 'Antecedentes de la incidencia',
      width: '99%',
      style: { overflow: 'hidden', 'max-height': '100vh' },
      styleClass: 'formEdition'
    };
    let context = {};
    // context['readonly'] = this.readOnly;
    context['contractModification'] = this.model;
    context['dossierId'] = this.model.division.parent.project.identifier;
    config['context'] = context;
    config.data = {
      task: this.task
    };


    this.waitService.startWaiting();
    this.subscribe(this.dialogService.open(AntecedentAYMADComponent, config).onClose,
      (materialSaved: boolean) => {

      },
      (error: any) => {
        this.waitService.cancelWaiting();
        console.error(error);

      });
  }

  public isSpecificAndOtherCausesVisibles(model: any) {
    this.isSpecificCauseRSCVisible(model);
    this.isOtherCauseRSCVisible(model);
  }

  public isSpecificCauseRSCVisible(model: any) {
    model['ui'].specificCauseRSCVisible =  false;
    if (model.cause && model.cause.generalCauses != null && model.cause.generalCauses.length > 0 && this.attrCAUSAS_RSC_GEN_ESP !== null && this.attrCAUSAS_RSC_GEN_ESP !== '') {
      this.attrCAUSAS_RSC_GEN_ESP.split(';').forEach(cause => {
        if (cause != null && cause !== '') {
          model.cause.generalCauses.forEach(generalCause => {
            if (generalCause != null && generalCause.identifier === cause + '<>CAUSAS_INCIDENCIA') {
              model['ui'].specificCauseRSCVisible = true
            }
          });
        }
      });
    }
  }


  public isOtherCauseRSCVisible(model: any) {
    model['ui'].otherCauseRSCVisible =  false;
    if (model.cause && model.cause.generalCauses != null && model.cause.generalCauses.length > 0 && this.attrCAUSAS_RSC_GEN_OTR !== null && this.attrCAUSAS_RSC_GEN_OTR !== '') {
      this.attrCAUSAS_RSC_GEN_OTR.split(';').forEach(cause => {
        if (cause != null && cause !== '') {
          model.cause.generalCauses.forEach(generalCause => {
            if (generalCause != null && generalCause.identifier === cause + '<>CAUSAS_INCIDENCIA') {
              model['ui'].otherCauseRSCVisible = true
            }
          });
        }
      });
    }
  }

  loadDataRSC() {
    this.subscribe(
      forkJoin([
        this.plycaService.getAttributeValue('CAUSAS_RSC_GEN_ESP')
          .pipe(catchError((error: any) => {
            console.error(error);
            return of(false)
          })),
        this.plycaService.getAttributeValue('CAUSAS_RSC_GEN_OTR')
        .pipe(catchError((error: any) => {
          console.error(error);
          return of(false)
        }))
      ]).pipe(
        tap((result: any[]) => {
          if (result) {
            if (result[0] !== undefined && result[0]?.singleResult !== undefined) {
              this.attrCAUSAS_RSC_GEN_ESP = result[0].singleResult;
            }
            if (result[1] !== undefined && result[1]?.singleResult !== undefined) {
              this.attrCAUSAS_RSC_GEN_OTR = result[1].singleResult;
            }
            this.isSpecificAndOtherCausesVisibles(this.model);
          }
        }
        )
      )
    );
  }

  public plannedPeriodRequestDateEditability(model: any) {
    let result = (model?.instanceType == null || model.instanceType.identifier !== 'De oficio<>TIPO_INSTANCIA')
    if (!result && model?.plannedPeriod != null) {
      model.plannedPeriod.requestDate = null;
    }
    return  result;
  }

  public isContractorResponability(model: any) {
    let result = model?.contractorResponability;
    if (!result && model != null) {
      model.incidentWarranty = null;
    }
    return result;
  }

}
